import { ApiPath } from "enums";
import { Get, Post } from "utils";

export const createChatThread = async ({ campaignCode, kind } = {}) => {
  const body = { campaignCode };

  if (kind) {
    body.kind = kind;
  }

  const res = await Post(ApiPath.SurveyChatThread, body);
  return res.data;
};

export const getChatThreads = async ({ campaignCode, kind, page = 1, perPage = 20 } = {}) => {
  const params = {
    campaignCode,
    page,
    perPage,
  };

  if (kind) {
    params.kind = kind;
  }

  const res = await Get(ApiPath.SurveyChatThread, {
    ...params,
  });
  return res.data;
};

export const getChatThreadMessages = async ({ insightChatThreadId, page = 1, perPage = 20 }) => {
  const res = await Get(`${ApiPath.SurveyChatThread}/${insightChatThreadId}/message`, {
    page,
    perPage,
  });
  return res.data;
};

export const createChatThreadMessage = async ({ insightChatThreadId, prompt, mapScope }) => {
  const body = { prompt };

  if (mapScope) {
    body.mapScope = mapScope;
  }

  const res = await Post(`${ApiPath.SurveyChatThread}/${insightChatThreadId}/message`, body);
  return res.data;
};
